export default __webpack_public_path__ + "static/media/GCAP-Brochure.c9b4ffe2.pdf";